import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./customBaseQuery";

export const SearchSkillsApiSlice = createApi({
  reducerPath: "searchSkills",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["skillsdata"],
  endpoints: (builder) => ({
    searchSkills: builder.query({
      query: (q) => ({
        url: `/utility/skills/${q}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useLazySearchSkillsQuery } = SearchSkillsApiSlice;
